export default __webpack_public_path__ + "static/media/uplaod.7c80d546.svg";